module.exports = __webpack_public_path__ + "img/apk.cfd8a2c0.svg";